/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voucher_DescInputs */

const en_voucher_desc = /** @type {(inputs: Voucher_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your code — the discount is applied on the pricing page.`)
};

const id_voucher_desc = /** @type {(inputs: Voucher_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan kodemu — diskon diterapkan di halaman harga.`)
};

/**
* | output |
* | --- |
* | "Enter your code — the discount is applied on the pricing page." |
*
* @param {Voucher_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_desc = /** @type {((inputs?: Voucher_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_desc(inputs)
	return en_voucher_desc(inputs)
});